import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'tx-modal',
  templateUrl: './tx-modal-component.html',
  styleUrls: ['./tx-modal-component.css']
})
export class TxModalComponent implements OnInit {
  _title: string;
  _message: string;
  _modalActions: any;
  _model: any;
  _refuseButton: string;
  _submitButton: string;
  _modalClass: string;
  _contentClass: string;

  @Output() txOnSubmit: EventEmitter<void> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  @Input()
  set title(title) {
    this._title = title;
  }

  get title() {
    return this._title;
  }

  @Input()
  set message(message) {
    this._message = message;
  }

  get message() {
    return this._message;
  }

  @Input()
  set modalActions(modalActions) {
    this._modalActions = modalActions;
  }

  get modalActions() {
    return this._modalActions;
  }

  @Input()
  set model(model) {
    this._model = model;
  }

  get model() {
    return this._model;
  }

  @Input()
  set refuseButton(refuseButton) {
    this._refuseButton = refuseButton;
  }

  get refuseButton() {
    return this._refuseButton;
  }

  @Input()
  set submitButton(submitButton) {
    this._submitButton = submitButton;
  }

  get submitButton() {
    return this._submitButton;
  }

  @Input()
  set modalClass(modalClass) {
    this._modalClass = modalClass;
  }

  get modalClass() {
    if (!this._modalClass) {
      this._modalClass = "default-modal";
    }
    return this._modalClass;
  }

  @Input()
  set contentClass(contentClass) {
    this._contentClass = contentClass;
  }

  get contentClass() {
    if (!this._contentClass) {
      this._contentClass = "default-modal-content";
    }
    return this._contentClass;
  }

  close() {
    this.modalActions.emit({ action: 'modal', params: ['close'] });
  }

  submit() {
    this.txOnSubmit.emit(this._model);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/component/tx-modal/tx-modal-component.ts